import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Form, Button, Card, Space } from "antd";
import { toast } from "react-toastify";
import FormFields from "./FormFields"; // On utilise le fichier local qu'on vient de modifier
import { useDispatch, useSelector } from "react-redux";
import { getProductByID, updateProduct } from "../../../redux/slices/products/productsThunk";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};

const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const EditProductPage = () => {
  // Correction du sélecteur loading (parfois c'est state.products.product.loading ou state.products.updatedProduct.loading)
  const product_loading = useSelector((state) => state.products.updatedProduct?.loading || false);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const history = useHistory();
  const { id } = useParams();

  const onFinish = (values) => {
    dispatch(updateProduct({
      id: id,
      productsData: values, // values contient maintenant productCode, family, etc.
    })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Produit modifié avec succès!");
        form.resetFields();
        navigateTo("/produit");
      } else {
        toast.error("Erreur pendant la modification!");
      }
    });
  };

  const navigateTo = (path) => {
    history.push(path);
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    dispatch(getProductByID(id)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        // --- REMPLISSAGE DES CHAMPS ---
        form.setFieldsValue({
          name: res.payload?.name,
          price: res.payload?.price,
          // Ajout des nouveaux champs
          productCode: res.payload?.productCode,
          family: res.payload?.family,
          barCode: res.payload?.barCode,
        });
      }}
    )
  }, [dispatch, id , form]);

  return (
    <div>
      <Card
        bordered
        className="criclebox tablespace mb-24"
        title="Modifier un Produit"
      />
      <Card bordered={false}>
        <Form {...layout} form={form} name="control-hooks" onFinish={onFinish}>
          <FormFields />
          <Form.Item {...tailLayout}>
            <Space size="small">
              <Button type="primary" htmlType="submit" loading={product_loading}>
                Enregistrer
              </Button>
              <Button htmlType="button" onClick={onReset}>
                Reset
              </Button>
              <Button
                type="link"
                htmlType="button"
                onClick={() => navigateTo("/produit")}
              >
                Annuler
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default EditProductPage;